import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay, faTrash, faUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import stopv2 from '../assets/stopv2.png'
import pause from '../assets/pause v2.png'
import stopwatch from '../assets/stopwatch.png'
import play from '../assets/play.png'
import useModalStore from "zustand/zustandstore";
let sections = [
  { key: "plan", label: "Plan" },
  { key: "assessment", label: "Assessment" },
  { key: "chief_complaint", label: "Chief Complaint" },
  { key: "doctor_instructions", label: "Doctor Instructions" },
  { key: "physical_examination", label: "Physical Examination" },
  { key: "history_of_present_illness", label: "History Of Present Illness" },
];

const MockeditEditScreen = ({ setIsexitModal,stopRecording,elapsedTime, formatTime,togglePause,isPaused,setIsPaused,
    stopTimer,pausedref, audioStreamRef, onDelete

}) => {
  const [dots, setDots] = useState(".");
  const mydata=useModalStore()
  if(mydata.usertype==='BUSINESS'){
    sections=[
      { key: "Date", label: "Date" },
      { key: "Action Items", label: "Action Items" },
      {key:'Decisions Made',label:'Decisions Made'},
      { key: "Additional Notes", label: "Additional Notes" },
      { key: "Topics Discussed", label: "Topics Discussed" },
   
    ]
  }
  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev === "." ? ".." : prev === ".." ? "..." : "."));
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="w-full min-h-screen p-8 flex flex-col ">
    <div className="flex w-full">  
        <div className="w-full mr-8 flex gap-4 items-center justify-end">
        

        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="22" viewBox="0 0 19 22" fill="none">
  <path d="M7.97192 2.5C7.68859 2.5 7.45126 2.404 7.25992 2.212C7.06859 2.02 6.97259 1.78267 6.97192 1.5C6.97126 1.21733 7.06726 0.98 7.25992 0.788C7.45259 0.596 7.68992 0.5 7.97192 0.5H11.9719C12.2553 0.5 12.4929 0.596 12.6849 0.788C12.8769 0.98 12.9726 1.21733 12.9719 1.5C12.9713 1.78267 12.8753 2.02033 12.6839 2.213C12.4926 2.40567 12.2553 2.50133 11.9719 2.5H7.97192ZM9.97192 13.5C10.2553 13.5 10.4929 13.404 10.6849 13.212C10.8769 13.02 10.9726 12.7827 10.9719 12.5V8.5C10.9719 8.21667 10.8759 7.97933 10.6839 7.788C10.4919 7.59667 10.2546 7.50067 9.97192 7.5C9.68926 7.49933 9.45192 7.59533 9.25992 7.788C9.06792 7.98067 8.97192 8.218 8.97192 8.5V12.5C8.97192 12.7833 9.06792 13.021 9.25992 13.213C9.45192 13.405 9.68926 13.5007 9.97192 13.5ZM9.97192 21.5C8.73859 21.5 7.57592 21.2627 6.48392 20.788C5.39192 20.3133 4.43792 19.6673 3.62192 18.85C2.80592 18.0327 2.16026 17.0783 1.68492 15.987C1.20959 14.8957 0.971924 13.7333 0.971924 12.5C0.971924 11.2667 1.20959 10.104 1.68492 9.012C2.16026 7.92 2.80592 6.966 3.62192 6.15C4.43792 5.334 5.39226 4.68833 6.48492 4.213C7.57759 3.73767 8.73992 3.5 9.97192 3.5C11.0053 3.5 11.9969 3.66667 12.9469 4C13.8969 4.33333 14.7886 4.81667 15.6219 5.45L16.3219 4.75C16.5053 4.56667 16.7386 4.475 17.0219 4.475C17.3053 4.475 17.5386 4.56667 17.7219 4.75C17.9053 4.93333 17.9969 5.16667 17.9969 5.45C17.9969 5.73333 17.9053 5.96667 17.7219 6.15L17.0219 6.85C17.6553 7.68333 18.1386 8.575 18.4719 9.525C18.8053 10.475 18.9719 11.4667 18.9719 12.5C18.9719 13.7333 18.7343 14.896 18.2589 15.988C17.7836 17.08 17.1379 18.034 16.3219 18.85C15.5059 19.666 14.5516 20.312 13.4589 20.788C12.3663 21.264 11.2039 21.5013 9.97192 21.5Z" fill="#2C5282"/>
</svg>
<div>        {formatTime(elapsedTime)}</div>
{!isPaused?<><div className="cursor-pointer" onClick={() => {
                togglePause()
               }}>
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M0.166748 3.25C0.166748 1.75691 0.166748 1.01116 0.630665 0.547245C1.09458 0.0833282 1.84033 0.0833282 3.33342 0.0833282C4.8265 0.0833282 5.57225 0.0833282 6.03616 0.547245C6.50008 1.01116 6.50008 1.75691 6.50008 3.25V12.75C6.50008 14.2431 6.50008 14.9888 6.03616 15.4527C5.57225 15.9167 4.8265 15.9167 3.33342 15.9167C1.84033 15.9167 1.09458 15.9167 0.630665 15.4527C0.166748 14.9888 0.166748 14.2431 0.166748 12.75V3.25ZM9.66675 3.25C9.66675 1.75691 9.66675 1.01116 10.1307 0.547245C10.5946 0.0833282 11.3403 0.0833282 12.8334 0.0833282C14.3265 0.0833282 15.0722 0.0833282 15.5362 0.547245C16.0001 1.01116 16.0001 1.75691 16.0001 3.25V12.75C16.0001 14.2431 16.0001 14.9888 15.5362 15.4527C15.0722 15.9167 14.3265 15.9167 12.8334 15.9167C11.3403 15.9167 10.5946 15.9167 10.1307 15.4527C9.66675 14.9888 9.66675 14.2431 9.66675 12.75V3.25Z" fill="#2C5282"/>
</svg>
  </div></>:
<div className="cursor-pointer"   onClick={() => {
                togglePause()
               }}>
  <FontAwesomeIcon icon={faPlay} />
</div>}
<div className="cursor-pointer"  onClick={()=> {
      if(!isPaused){
       stopTimer()
       pausedref.current=false
       setIsPaused(true)
    //    if(isError){
    //     pausemanualRecording()
    //    }
       
      }
         setIsexitModal(true)

             //   pauseRecording();
                                           
               }}><svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
               <path d="M0 13V3C0 2.3125 0.245 1.72417 0.735 1.235C1.225 0.745833 1.81333 0.500833 2.5 0.5H12.5C13.1875 0.5 13.7762 0.745 14.2662 1.235C14.7562 1.725 15.0008 2.31333 15 3V13C15 13.6875 14.7554 14.2762 14.2662 14.7662C13.7771 15.2562 13.1883 15.5008 12.5 15.5H2.5C1.8125 15.5 1.22417 15.2554 0.735 14.7662C0.245833 14.2771 0.000833333 13.6883 0 13Z" fill="#2C5282"/>
             </svg></div>
<div className="text-red-500 cursor-pointer"
onClick={() => {
    if(!pausedref.current){
      stopTimer()
      setIsPaused(true)
      pausedref.current=false              
     
     }
    onDelete()
  }}
>
<FontAwesomeIcon icon={faTrash}  />

</div>

        </div>


    </div>
      <div className="w-full mt-4 grid grid-cols-1 sm:grid-cols-3 gap-4">
      {sections.map((section, idx) => {
        let customClasses = "";
        if (idx % 6 === 0 || idx % 6 === 1 || idx % 6 === 2) {
          customClasses = "col-span-3 sm:col-span-1 min-h-[120px]";
        } else if (idx % 6 === 3) {
          customClasses = "col-span-3 min-h-[120px]";
        } else if (idx % 6 === 4) {
          customClasses = "col-span-3 sm:col-span-1 min-h-[120px]";
        } else {
          customClasses = "col-span-3 sm:col-span-2 min-h-[120px]";
        }

        return (
          <div
            key={section.key}
            className={`flex flex-col justify-start items-start w-auto max-w-full ${customClasses}`}
            style={{
              borderRadius: "8px",
              border: "1px solid rgba(162, 198, 253, 0.40)",
              background: "#FFF",
              boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
              flex: "1 0 auto",
            }}
          >
            <div className="flex items-center justify-between w-full h-10 px-4 bg-blue-100 rounded-md">
              <h1 className="text-sm font-bold text-[#262629]">
                {section.label}
              </h1>
              <div className="flex items-center gap-4">
                {section.label === "Doctor Instructions" && (
                  <ShareOutlinedIcon
                    sx={{ fontSize: "18px", color: "#676767", cursor: "pointer" }}
                  />
                )}
                <FontAwesomeIcon
                  icon={faUpRightFromSquare}
                  className="text-[#7E7E7E] cursor-pointer"
                />
              </div>
            </div>
            <div className="w-full flex justify-start p-4 text-[#374151]">
              <div className="text-lg">{dots}</div>
            </div>
           
           
          </div>
        );
      })}
    </div>
    </div>
  
  );
};

export default MockeditEditScreen;
